import api from './leadsApi';

export const getPipeline = () => api.get('/pipeline');
export const savePipeline = (data) => api.put('/pipeline', data);

export const getCustomStages = () => api.get('/pipeline/stages');
export const createCustomStage = (data) => api.post('/pipeline/stages', data);
export const updateCustomStage = (id, data) => api.patch(`/pipeline/stages/${id}`, data);
export const deleteCustomStage = (id) => api.delete(`/pipeline/stages/${id}`);
